export default function isUndefined(input) {
    return input === void 0;
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/is-undefined.js
// module id = 154
// module chunks = 113